import * as types from './types';
export default({
  // STORAGE
  [types.UPDATE_STORE]: (context, payload) => {
    context.commit(types.UPDATE_STORE, payload);
  },
  [types.RESET_STATE]: (context) => {
    context.commit(types.RESET_STATE);
  },
  // APPLICATION OPTIONS
  [types.UPDATE_STEPS]: (context, payload) => {
    context.commit(types.UPDATE_STEPS, payload);
  },
  // SET NOTIFICATION
  [types.SET_NOTIFICATION]: (context, payload) => {
    context.commit(types.SET_NOTIFICATION, payload);
  },
  [types.SET_WORDING]: (context, payload) => {
    context.commit(types.SET_WORDING, payload);
  },
  [types.SET_SUPPLIER]: (context, payload) => {
      context.commit(types.SET_SUPPLIER, payload);
  },
  [types.SET_MAX_PANELS]: (context, payload) => {
      context.commit(types.SET_MAX_PANELS, payload);
  },
  // SET LOADER
  [types.SET_LOADER]: (context, payload) => {
    context.commit(types.SET_LOADER, payload);
  },
  // SELECTION OPTIONS
  [types.SET_BUILDINGS]: (context, payload) => {
    context.commit(types.SET_BUILDINGS, payload);
  },
  [types.SET_BUILDING]: (context, payload) => {
      context.commit(types.SET_BUILDING, payload);
  },
  [types.SET_ACTIVE_BUILDING]: (context, payload) => {
    context.commit(types.SET_ACTIVE_BUILDING, payload);
  },
  [types.SET_ACTIVE_FIELD]: (context, payload) => {
    context.commit(types.SET_ACTIVE_FIELD, payload);
  },
  [types.SET_PANELS]: (context, payload) => {
    context.commit(types.SET_PANELS, payload);
  },
  // PANEL OPTIONS
  [types.UPDATE_PANEL_PRICE]: (context, payload) => {
      context.commit(types.UPDATE_PANEL_PRICE, payload);
  },
  [types.SET_SELECTED_PANEL]: (context, payload) => {
    context.commit(types.SET_SELECTED_PANEL, payload);
  },
  [types.REMOVE_SELECTED_PANEL]: (context, payload) => {
    context.commit(types.REMOVE_SELECTED_PANEL, payload);
  },
  [types.ERASE_SELECTED_PANEL]: (context) => {
    context.commit(types.ERASE_SELECTED_PANEL);
  },
  [types.UPDATE_PANEL_NAME]: (context, payload) => {
    context.commit(types.UPDATE_PANEL_NAME, payload);
  },
  [types.UPDATE_PANEL_STATUS]: (context, payload) => {
    context.commit(types.UPDATE_PANEL_STATUS, payload);
  },
  // OWNER OPTIONS
  [types.TOGGLE_OWNER_PANEL]: (context, payload) => {
    context.commit(types.TOGGLE_OWNER_PANEL, payload);
  },
  [types.SET_OWNER]: (context, payload) => {
    context.commit(types.SET_OWNER, payload);
  },
  // PANEL OPTIONS
  [types.SET_CUSTOMER]: (context, payload) => {
    context.commit(types.SET_CUSTOMER, payload);
  },
  // ORDER
  [types.ORDER_CREATED]: (context) => {
    context.commit(types.ORDER_CREATED);
  },
  // ORDER
  [types.UPDATE_PDF]: (context, payload) => {
    context.commit(types.UPDATE_PDF, payload);
  },
});



// WEBPACK FOOTER //
// ./src/store/actions.js